<template>
    <div class="row">
        <div class="col-md-12 text-center">
            <h2><i class="fas fa-users text-danger"></i>&nbsp;Accesso Partecipanti</h2>
        </div>
    </div>
    <div class="login-container">
        
        <div class="login-box row">
            <!-- Form di login -->
            <div class="col-md-6 col-lg-6 login-form">
                <h2>Accedi</h2>
                <form>
                    <div class="mb-3">
                        <label class="form-label">Email partecipante</label>
                        <input type="text" class="form-control" v-model="oLogin.username" placeholder="Inserisci la mail">
                    </div>
                    <div class="mb-3">
                        <label class="form-label">Codice di accesso</label>
                        <input type="password" class="form-control" v-model="oLogin.password" placeholder="Inserisci il codice di accesso" @keypress.enter="DoLogin">
                    </div>
                    <button type="button" class="btn btn-primary" @click="DoLogin">Accedi</button>

                    <messaggio-standard 
                        :mostraMessaggio="mostraMessaggio"
                        :alertClass="alertClass"
                        :alertIcon="alertIcon"
                        :alertIconSpin="alertIconSpin"
                        :alertMessaggio="alertMessaggio"
                        fontawesome="standard"
                        ></messaggio-standard>
                </form>
            </div>
            <!-- Logo aziendale -->
            <div class="col-md-6 col-lg-6 login-logo d-none d-lg-flex">
                <img src="img/bucher.jpg" alt="Logo Azienda">
            </div>
        </div>
    </div>
</template>

<script>

import MessaggioStandard from '@/components/MessaggioStandard.vue';

export default {
    name: 'LoginView',
    components: {
        MessaggioStandard
    },
    inject: ['cfg'],
    data: function () {
    return {
      oLogin: {
          username: "",
          password: ""
      },

      mostraMessaggio: false,
      alertMessaggio: "",
      alertClass: "",     
      alertIcon: "",
      alertIconSpin: false  
      
    }
  },
  methods: {
    DoLogin()  {
      this.mostraMessaggio = true;
        this.alertMessaggio = ["Accesso in corso..."]; //<i class='fas fa-circle-notch fa-spin'></i>&nbsp;
        this.alertClass = "alert alert-primary";
        this.alertIcon = "fa-spinner"
        this.alertIconSpin = true

        //Invia login 
        fetch(this.cfg.apisrv + "/api/AccPartecipante/DoLogin", {
                "method": "POST",
                "headers": {
                    'Accept': 'text/plain',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.oLogin)
            })
        .then(response => response.json())
        .then(obj => {
            if (obj.status == "OK") {
                //Setta lo store vuex con il token
                this.$store.commit('UserInfo', obj.moreJsonData);
                this.$store.commit('dataLogin', new Date());
                

                this.mostraMessaggio = true;
                this.alertMessaggio = ["Fatto. Redirezione in corso..."]; //<i class='fas fa-circle-notch fa-spin'></i>&nbsp;
                this.alertClass = "alert alert-success";
                this.alertIcon = "fa-spinner"
                this.alertIconSpin = true

              

                //alert(obj.moreJsonData.status)
                this.$router.push("/dashboard");
                                
                //window.location.href= "/dash";
                //alert(this.$store.state.token);
            }
            else {
                if(obj.nextStep == 'resetPass') {
                    this.mostraLogin = false;
                    this.mostraReset = true;
                    this.mostraMessaggio = false;

                    //Inizializza l'oggetto reset
                    this.oLoginReset.tokenp = obj.moreJsonData.token;
                    this.oLoginReset.username = this.oLogin.username;
                    this.oLoginReset.vecchiap = this.oLogin.password;


                } else {
                    this.mostraMessaggio = true;
                    this.alertMessaggio = [obj.errorMessage];
                    this.alertClass = "alert alert-warning";
                    this.alertIcon = "fa-xmark"
                    this.alertIconSpin = false

                }
                
            }
        });
    },
  },
  created() {
    
  },
    beforeUnmount() {
    
  },
  mounted: function() {
    if(this.$route.query.email != null ) {
        this.oLogin.username = this.$route.query.email;
    }
    if(this.$route.query.accessCode != null ) {
        this.oLogin.password = this.$route.query.accessCode;
    }
  }
  }
</script>

